import React, { forwardRef } from 'react';
import { SearchableSelect } from './SearchableSelect';

interface SelectOption {
  value: string | number;
  label: string;
  disabled?: boolean;
}

interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'children'> {
  label?: string;
  error?: string;
  hint?: string;
  options: SelectOption[];
  placeholder?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, error, hint, options, placeholder, className, id, value, onChange, ...props }, _ref) => {
    // Map existing options ({value,label}) directly to SearchableSelect.
    const searchableOptions = options.map((option) => ({
      value: option.value,
      label: option.label,
    }));

    // Native select value can be string | number | readonly string[]; normalize
    // to the string | number that SearchableSelect expects ('' => unselected).
    const normalizedValue: string | number = Array.isArray(value)
      ? (value[0] ?? '')
      : (value ?? '');

    return (
      <SearchableSelect
        options={searchableOptions}
        value={normalizedValue}
        onChange={(v) =>
          onChange?.({
            target: { value: String(v), name: props.name },
          } as unknown as React.ChangeEvent<HTMLSelectElement>)
        }
        placeholder={placeholder}
        label={label}
        required={props.required}
        disabled={props.disabled}
        className={className}
        error={error}
        hint={hint}
        id={id}
        name={props.name}
      />
    );
  }
);

Select.displayName = 'Select';
